<template>
  <bm-text v-bind="$attrs" :value="value" @input="$emit('input', $event)">
    <template v-if="value" #readOnly>
      <a :href="telephoneHref"
        ><v-icon>{{ $vuetify.icons.values[icons.phone] }}</v-icon
        >{{ value }}</a
      >
    </template>
  </bm-text>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useThemedIcons } from "@/plugins/vuetify";
export default defineComponent({
  name: "BmTelephone",
  props: {
    value: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const { icons } = useThemedIcons();
    const telephoneHref = computed(() => `tel:${props.value}`);
    return {
      icons,
      telephoneHref,
    };
  },
});
</script>

<style scoped lang="sass">
a
  margin-top: .3em
  display: block

a i.v-icon
  width: 25px
  height: 25px
  margin-right: 0.25em
  margin-left: 0
  transform: rotate(90deg)
</style>
